import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Munchkin } from './services/munchkin.provider';
import { APP_BASE_HREF, LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';

import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FaIconLibrary, } from '@fortawesome/angular-fontawesome';

import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import localeJa from '@angular/common/locales/ja';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

export  const getLocale =  () => window.location.href === 'https://m-myweekly.playbac.jp/' ? 'ja' : 'fr';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeJa, 'ja');
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        TranslateModule.forRoot({
            defaultLanguage: 'fr',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ShareButtonsModule.withConfig({
            debug: true,
            prop: {
                twitter: {
                    icon: ['fab', 'x-twitter'],
                    color: '#1E3050',
                },
            },
        }),
        ShareIconsModule,
        SharedModule,
        GoogleTagManagerModule.forRoot({ id: 'GTM-NXF5N45' })], providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: ErrorHandler, useClass: ErrorHandler },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: LOCALE_ID, useValue: getLocale() },
        Munchkin,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
    constructor(iconLibrary: FaIconLibrary) {
        iconLibrary.addIcons(faXTwitter);
    }
}
